import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  title: "View invoice in new tab",
  class: "search-with-button",
  style: {"padding-left":"1rem","padding-right":"1rem"}
}
const _hoisted_2 = {
  class: "date-picker",
  style: {"width":"60%"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, " Select Journal Type... ", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = ["disabled"]

import {
    currentTab,
    dateRange,
    displayAmountVATTotal,
    displayedVATReturns,
    infoError,
    isDateSearch,
    isLoading,
    journalReference,
    journalTypeSelectionDate,
    tabs,
    textInputOptions,
    validJournalReferences,
    supportedJournalingTypes,
} from "@/services/helpers/VATReturns/VATReturnsVariables";
import { FormatDatePicker } from "@/services/helpers/Helper";
import VATReturnsServices from "@/services/helpers/VATReturns/VATReturnsHelper";
import DatePicker from '@vuepic/vue-datepicker';
import log from "loglevel";
import { IAPILogger } from "@/interfaces/IAPILogger";
import { inject } from "vue";
import IJournalVATResponse from "@/Interfaces/VATReturns/IJournalVATResponse";
import { DisplayVATReturns, DisplayVATReturnsNotFound } from "@/services/helpers/VATReturns/VATReturnsFunctions";
import JournalVAT from "@/models/VATReturns/JournalVat";
import INotFoundError from "@/Interfaces/Errors/INotFoundError";
import { AxiosError } from "axios";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";


const fileName = "VATReturnsDatePicker.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'VATReturnsDatePicker',
  setup(__props) {

const JVATServices: VATReturnsServices = new VATReturnsServices();
const Logger: IAPILogger = inject("Logger")!;
function search() {
    // Logging
    const name = "search";
    const prefix = `${name}()\r\n`;
    log.trace(`${name}{}`);

    SearchForDateRange();

    currentTab.value = tabs.Summary;
}

async function SearchForDateRange() {
    isLoading.value = true;
    isDateSearch.value = true;
    journalReference.value = "";
    validJournalReferences.value = [];

    const name = SearchForDateRange.name;
    const prefix = `${name}()\n`;
    const Class = fileName + "/" + name;
    var Message = `Searching for Invoices files (Journal Reference: ${journalReference.value}).`;

    const dateFrom: string = dateRange.value![0].toLocaleString('sv-SE').split(" ")[0];
    const dateTo: string = dateRange.value![1].toLocaleString('sv-SE').split(" ")[0];

    log.trace(prefix + Message);
    await JVATServices.GetVATReturnsByDate(dateFrom, dateTo)
        .then((response: IJournalVATResponse) => {
            log.trace("SearchForDateRange() Response:", response);
            DisplayVATReturns(response);

            displayAmountVATTotal.value = (displayedVATReturns.value ?? []).reduce((partialSum: number, vatReturn: JournalVAT) => {
                log.trace(prefix + "vatReturn:", vatReturn, "\nJournalVATMetaData:", vatReturn.JournalVATMetaData);
                for (const metadata of vatReturn.JournalVATMetaData.AccountingMetaData) {
                    partialSum += metadata.IsIncrease
                        ? (metadata.UseAmountVAT ? vatReturn.AmountVat : vatReturn.AmountExVat)
                        : - (metadata.UseAmountVAT ? vatReturn.AmountVat : vatReturn.AmountExVat)
                }
                return partialSum;
            }, 0);

            Logger.LogInformation(Message, Class);
        })
        .catch((error: any) => {
            if (error instanceof AxiosError && error.response?.status == 400) {
                DisplayVATReturnsNotFound(error as INotFoundError);
            } else {
                if (error instanceof AxiosError) {
                    isLoading.value = false;
                    useNotifierWithErrFormatter().error({error, errorType: "Getting VAT Returns"})
                    infoError.value = true;
                }
                Message = `(Error) ${Message}: ${error instanceof AxiosError ? error : error.message
                    }`;
                log.error(Message);
                Logger.LogError(Message, Class);
            }
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DatePicker), {
        modelValue: _unref(dateRange),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dateRange) ? (dateRange).value = $event : null)),
        range: "",
        "enable-time-picker": false,
        format: _unref(FormatDatePicker),
        "text-input": "",
        placeholder: "Select Date...",
        "text-input-options": _unref(textInputOptions),
        "partial-range": false
      }, null, 8, ["modelValue", "format", "text-input-options"])
    ]),
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(journalTypeSelectionDate) ? (journalTypeSelectionDate).value = $event : null)),
      class: "embedded-dropdown",
      style: {"width":"40%"}
    }, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(supportedJournalingTypes), (jType) => {
        return (_openBlock(), _createElementBlock("option", {
          value: jType.Canonical,
          key: jType.Canonical
        }, _toDisplayString(jType.DisplayShort), 9, _hoisted_4))
      }), 128))
    ], 512), [
      [_vModelSelect, _unref(journalTypeSelectionDate)]
    ]),
    _createElementVNode("button", {
      ref: "invoiceSearchButton",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (search())),
      disabled: _unref(dateRange) == undefined ||
            _unref(journalTypeSelectionDate) == ''
            ,
      class: "right-button"
    }, " Search ", 8, _hoisted_5)
  ]))
}
}

})